var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppInside(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 49,
    viewBox: "0 0 81 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.3275 0.766316C42.9618 1.36536 42.1471 2.44361 41.596 4.33641C41.3326 5.22295 38.7928 14.136 35.9416 24.1513C30.4787 43.3432 30.3349 43.9662 31.1735 45.7152C32.1319 47.728 34.4321 48.7342 36.7322 48.1352C38.1459 47.7758 39.5115 46.8174 40.0148 45.8591C40.2064 45.4757 42.842 36.4188 45.8849 25.6847C50.9404 7.90638 51.4197 6.06154 51.3478 4.69578C51.2759 3.47378 51.1322 3.04253 50.5331 2.29974C48.9758 0.383018 46.5079 -0.239941 44.3275 0.766316Z",
    fill: "url(#paint0_linear_1112_959)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1335 5.2949C15.5999 6.08565 3.16475 16.7478 2.35008 17.9697C0.720864 20.4137 0.481201 21.2283 0.481201 24.5109C0.481201 27.386 0.505123 27.5777 1.24791 29.1352C1.67917 30.0456 2.35008 31.1956 2.75742 31.6989C3.57208 32.7291 15.6479 42.8881 16.9897 43.7028C18.2116 44.4216 20.2483 44.4216 21.6618 43.7028C24.2974 42.337 24.9683 38.3357 22.9317 36.1554C22.5723 35.796 19.745 33.352 16.6542 30.7405C13.5634 28.1288 10.832 25.7807 10.5923 25.5171C9.56202 24.391 9.87356 24.0317 16.6302 18.3531C20.4159 15.1904 23.1953 12.6746 23.5307 12.1235C24.1298 11.1172 24.2735 9.03267 23.8182 7.81078C23.4828 6.9002 22.2129 5.60644 21.2784 5.19911C20.1764 4.7199 18.1158 4.76786 17.1335 5.2949Z",
    fill: "url(#paint1_linear_1112_959)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9017 5.19895C58.9912 5.60628 57.7453 6.92408 57.4098 7.8105C57.2661 8.19392 57.1462 9.1283 57.1462 9.89513C57.1462 11.0691 57.2661 11.4525 57.937 12.3869C58.3443 12.9859 61.4351 15.8132 64.7655 18.6405C71.6421 24.5346 71.5702 24.3909 69.7971 26.092C69.2221 26.6431 66.5147 29.0152 63.7352 31.3872C60.9799 33.7592 58.464 35.9635 58.1765 36.275C57.4337 37.0896 57.1462 38.0001 57.1462 39.5815C57.1462 41.3545 58.0807 42.9359 59.5662 43.7026C60.9559 44.3975 63.0165 44.4214 64.2144 43.7266C65.4844 42.9598 77.5602 32.5852 78.3269 31.6028C78.6863 31.1236 79.3092 30.0214 79.7406 29.111C80.4833 27.5776 80.5073 27.3858 80.5073 24.4867C80.5073 21.5156 80.5073 21.4917 79.6208 19.6947C79.1176 18.7363 78.3748 17.5144 77.9436 17.0352C76.6977 15.6215 64.7896 5.55832 63.9269 5.19895C62.9446 4.76758 60.8362 4.79161 59.9017 5.19895Z",
    fill: "url(#paint2_linear_1112_959)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1112_959",
    x1: 41,
    y1: -18,
    x2: 31,
    y2: 62.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6250FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEBAF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1112_959",
    x1: -17,
    y1: -18,
    x2: 93.5,
    y2: 89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6250FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#C2D6F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1112_959",
    x1: 59.7239,
    y1: 5.39481,
    x2: 93.5,
    y2: 53.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6250FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2D6F3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppInside);
export default __webpack_public_path__ + "static/media/App-inside.367fe7de4825c5a07897fa215cf32009.svg";
export { ForwardRef as ReactComponent };